import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable()
export class AdminManagerGuardService {

  constructor( private  _authService: AuthService, private router : Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):Observable<boolean> | Promise<boolean> | boolean{
    
    if ((this._authService.isLoggedIn() && this._authService.isAdmin()) || (this._authService.isLoggedIn() && this._authService.isManager())) {
      return true;
    } else {
      this.router.navigate(['/acceuil'])
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/gaurds/admin-manager-guard.service.ts